import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../../../Components/layouts";
import { SkillsAndTransformation } from 'Services/SkillsAndTransformation';
import { Badge, Button, Grid, Input, LinearProgress, Typography } from '@material-ui/core';
import MenuList from "@material-ui/core/MenuList";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import MenuItem from "@material-ui/core/MenuItem";
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { notify } from 'utils';
import ConfirmationModal from 'Components/ConfirmationModal';
import { UserServices } from '../../../../Services/UserServices';
import { useHistory, useLocation } from 'react-router';
import { Pagination } from '@material-ui/lab';
import { DEFAULT_COURSE_IMAGE_URL } from 'utils/constants';
import { cardAccent, chipSurface } from '../LearningHub/helpers';
import {
    catalogueCategories,
    catalogueCourses,
    catalogueTotalCount,
    cataloguePagination,
    catalogueQuery,
    CATALOGUE_PAGE_SIZE,
} from './catalogue';

const skillsAndTransformation = new SkillsAndTransformation();
const userServices = new UserServices();

const useStyles = makeStyles((theme) => ({
    activeMenu: {
        background: "#3D7DDD",
        color: "#fff",
    },
    sidebarMenu: {
        background: "#FAFCFF",
        border: '1px solid #DEDEDE',
        boxShadow: "0px 4px 30px rgba(12, 41, 84, 0.1)",
        borderRadius: 5,
        overflow: "auto",
        padding: theme.spacing(0, 1),
        maxHeight: '45vh',
        [theme.breakpoints.up('sm')]: {
            maxHeight: '60vh',
            padding: theme.spacing(0, 1.5),
        },
        [theme.breakpoints.up('md')]: {
            maxHeight: 'none',
            height: '100vh',
            padding: theme.spacing(0, 1),
        },
    },
    sidebarTitle: {
        margin: theme.spacing(2, 0, 1),
        fontSize: '1.1rem',
        fontWeight: 600,
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.25rem',
        },
        [theme.breakpoints.up('md')]: {
            margin: theme.spacing(2, 0, 1),
            fontSize: '1.35rem',
        },
    },
    categoryList: {
        paddingTop: 0,
        '& .MuiMenuItem-root': {
            marginBottom: theme.spacing(1),
            borderRadius: 4,
        },
        '& .MuiMenuItem-root:last-child': {
            marginBottom: 0,
        },
    },
    cardDetails: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        overflow: 'visible',
        boxSizing: 'border-box',
        padding: theme.spacing(2, 2.25),
        backgroundImage: 'linear-gradient(165deg, var(--card-wash, transparent) 0%, transparent 62%)',
        '&:last-child': {
            paddingBottom: 16,
        },
    },
    title: {
        fontWeight: 700,
        fontSize: '1rem',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.2rem',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: 21,
        },
    },
    desc: {
        margin: '12px 0',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        [theme.breakpoints.up('sm')]: {
            margin: '16px 0',
        },
        [theme.breakpoints.up('md')]: {
            margin: '20px 0',
        },
    },
    descBox: {
        flex: 1,
        minHeight: 48,
        maxHeight: 72,
        overflowY: 'auto',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        [theme.breakpoints.up('sm')]: {
            maxHeight: 100,
        },
        [theme.breakpoints.up('md')]: {
            maxHeight: 100,
        },
    },
    lockIcon: {
        fontSize: 20,
        color: '#94a3b8',
        flexShrink: 0,
    },
    unLockIcon: {
        fontSize: 20,
        color: '#12924a',
        flexShrink: 0,
    },
    mainContent: {
        overflow: "auto",
        minHeight: '50vh',
        [theme.breakpoints.up('md')]: {
            height: '100vh',
            minHeight: '100vh',
        },
    },
    courseActionBtn: {
        borderRadius: '999px !important',
        minHeight: 36,
        padding: '0 16px',
        color: '#fff !important',
        fontSize: 13,
        fontWeight: 650,
        letterSpacing: '0.01em',
        minWidth: 0,
        textTransform: 'none',
        boxShadow: 'none !important',
        transition: 'filter 150ms ease',
        '&:hover': {
            boxShadow: 'none !important',
            filter: 'brightness(0.94)',
        },
    },
    requestBtn: {
        backgroundColor: 'var(--card-accent, #2f6fde) !important',
        '&:hover': {
            backgroundColor: 'var(--card-accent, #2f6fde) !important',
        },
    },
    launchBtn: {
        backgroundColor: '#12924a !important',
        '&:hover': {
            backgroundColor: '#12924a !important',
        },
    },
    cardRoot: {
        minHeight: 120,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        overflow: 'hidden',
        borderRadius: 8,
        '& .MuiCardContent-root': {
            overflow: 'visible',
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 140,
        },
        [theme.breakpoints.up('md')]: {
            minHeight: 160,
        },
    },
    thumbnailWrap: {
        position: 'relative',
        width: '100%',
        backgroundColor: '#f5f8fc',
        borderBottom: '1px solid #e7ebf0',
        overflow: 'hidden',
        lineHeight: 0,
    },
    thumbnailPending: {
        minHeight: 180,
    },
    categoryOverlay: {
        position: 'absolute',
        top: 12,
        left: 12,
        zIndex: 1,
        maxWidth: 'calc(100% - 24px)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: '#fff',
        backgroundColor: 'rgba(23, 32, 51, 0.82)',
        borderRadius: 8,
        padding: '5px 10px',
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.3,
    },
    thumbnail: {
        display: 'block',
        width: '100%',
        height: 'auto',
        opacity: 0,
        transition: 'opacity 0.2s ease',
    },
    thumbnailLoaded: {
        opacity: 1,
    },
    cardActionsRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginTop: 16,
        paddingTop: 12,
        gap: 8,
        minWidth: 0,
        flexShrink: 0,
        borderTop: '1px solid rgba(148, 163, 184, 0.28)',
    },
    inputStyle: {
        borderColor: '#838383',
        borderRadius: '25px',
    },
    countIcon: {
        '& .MuiBadge-anchorOriginTopRightRectangle': {
            backgroundColor: 'gray',
            color: '#FFF'
        }
    },
    coursesGrid: {
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1, 0),
        },
        alignItems: 'stretch',
    },
    paginationRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(2),
    },
}));

const LazyThumbnail = ({ src, alt, wrapClassName, pendingClassName, imageClassName, loadedClassName, rootRef, overlay }) => {
    const placeholderRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const node = placeholderRef.current;
        if (!node || isVisible) {
            return undefined;
        }

        if (typeof IntersectionObserver === 'undefined') {
            setIsVisible(true);
            return undefined;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            {
                root: rootRef?.current || null,
                rootMargin: '240px 0px',
                threshold: 0.01,
            }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, [isVisible, rootRef]);

    return (
        <div className={`${wrapClassName}${isLoaded ? '' : ` ${pendingClassName || ''}`}`} ref={placeholderRef}>
            {isVisible ? (
                <img
                    className={`${imageClassName}${isLoaded ? ` ${loadedClassName}` : ''}`}
                    src={src}
                    alt={alt}
                    decoding="async"
                    onLoad={() => setIsLoaded(true)}
                />
            ) : null}
            {overlay}
        </div>
    );
};

const catalogueCornerLabel = (course) => {
    const value = typeof course?.category === 'string' ? course.category.trim() : '';
    return value && value !== '0' ? value : '';
};

const CourseItem = ({ course, handleCourseAction, scrollRootRef }) => {
    const classes = useStyles();
    const imageUrl = (course.imageUrl || course.thumbnail_url || '').trim() || DEFAULT_COURSE_IMAGE_URL;
    const cornerLabel = catalogueCornerLabel(course);
    const accent = cardAccent(cornerLabel || course.name);

    return (
        <Grid item xs={12} sm={6} md={6} lg={6}>
            <Card
                className={classes.cardRoot}
                style={{ '--card-accent': accent, '--card-wash': `${accent}29` }}
            >
                <LazyThumbnail
                    src={imageUrl}
                    alt={course.name}
                    wrapClassName={classes.thumbnailWrap}
                    pendingClassName={classes.thumbnailPending}
                    imageClassName={classes.thumbnail}
                    loadedClassName={classes.thumbnailLoaded}
                    rootRef={scrollRootRef}
                    overlay={cornerLabel ? (
                        <span className={classes.categoryOverlay} style={{ backgroundColor: chipSurface(accent) }}>
                            {cornerLabel}
                        </span>
                    ) : null}
                />
                <CardContent className={classes.content}>
                    <div className={classes.descBox}>
                        <Typography className={classes.title} color="primary">
                            {course.name}
                        </Typography>
                        <Typography variant="subtitle2" className={classes.desc} color="textSecodary">
                            {course.description ? course.description : "Description not available"}
                        </Typography>
                    </div>
                    <div className={classes.cardActionsRow}>
                        {course.locked
                            ? <LockIcon className={classes.lockIcon} />
                            : <LockOpenIcon className={classes.unLockIcon} />}
                        <Button
                            className={`${classes.courseActionBtn} ${course.locked ? classes.requestBtn : classes.launchBtn}`}
                            onClick={() => handleCourseAction(course)}
                        >
                            {course.locked ? "Request" : "Launch"}
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </Grid >
    );
}

const CourseCatalogue = () => {

    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [courseCatalogueList, setCourseCatalogueList] = useState([]);
    const [pageCourses, setPageCourses] = useState([]);
    const [pagination, setPagination] = useState({ pageno: 0, perpage: CATALOGUE_PAGE_SIZE, data_count: 0, total_pages: 0, has_next: false });
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [requestLoading, setRequestLoading] = useState(false);
    const [user, setUser] = useState(null);
    const [comment, setComment] = useState("");
    const location = useLocation();
    const history = useHistory();
    const coursesPanelRef = useRef(null);
    const query = new URLSearchParams(location.search);
    const activeCatalogue = query.get('category') || '';
    const pageIndex = (() => {
        const parsed = Number(query.get('pageno'));
        return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
    })();

    useEffect(() => {
        if (coursesPanelRef.current) {
            coursesPanelRef.current.scrollTop = 0;
        }
    }, [activeCatalogue, pageIndex]);

    useEffect(() => {
        getUserDetails();
    }, [location]);

    useEffect(() => {
        let mounted = true;
        const loadCatalogue = async () => {
            setLoading(true);
            setPageCourses([]);
            const response = await skillsAndTransformation.getCourseCatalogue(
                catalogueQuery({
                    category: activeCatalogue,
                    pageno: pageIndex,
                    perpage: CATALOGUE_PAGE_SIZE,
                })
            );
            if (!mounted) {
                return;
            }
            if (response?.status) {
                setCourseCatalogueList(catalogueCategories(response));
                setPageCourses(catalogueCourses(response));
                setPagination(cataloguePagination(response.pagination, catalogueCourses(response)));
            } else {
                setPageCourses([]);
                notify('error', response?.message || 'Unable to load the course catalogue');
            }
            setLoading(false);
        };
        loadCatalogue();
        return () => {
            mounted = false;
        };
    }, [activeCatalogue, pageIndex]);

    async function getUserDetails() {
        const user = await userServices.getDetailMyProfile();
        if (user && user.data && user.data.length) {
            setUser(user.data[0]);
        }
    }

    const updateCatalogueQuery = ({ category = '', pageno = 0 }) => {
        const params = new URLSearchParams(location.search);
        if (category) {
            params.set('category', category);
        } else {
            params.delete('category');
        }
        if (pageno > 0) {
            params.set('pageno', String(pageno));
        } else {
            params.delete('pageno');
        }
        const search = params.toString();
        history.replace({ pathname: location.pathname, search: search ? `?${search}` : '' });
    };

    const handleCLickMenuItem = (item) => {
        updateCatalogueQuery({ category: item?.category || '', pageno: 0 });
    };

    const handleCourseAction = (course) => {
        if (course.locked) {
            setSelectedCourse(course);
            setOpenConfirmModal(true);
        } else {
            if (course.link) {
                window.open(course.link, "_blank")
            } else {
                notify('error', "Requested link not available")
            }
        }
    }

    const handleRequestSubmit = async () => {
        if (selectedCourse && user) {
            setRequestLoading(true);
            const payload = {
                course: selectedCourse.uuid,
                user: user.uuid,
                status: 'pending',
                comment
            };
            try {
                await skillsAndTransformation.sendCourseRequest(payload);
                setRequestLoading(false);
                setOpenConfirmModal(false);
                setSelectedCourse(null);
                setComment("");
                notify('success', "Request submited successfully");
            } catch (e) {
                setRequestLoading(false);
                setOpenConfirmModal(false);
                setSelectedCourse(null);
                console.log("Error: ", e.response);
                if (e.response && e.response.data) {
                    notify('error', e.response.data.message);
                    return null;
                }
                notify('error', "Something went wrong");
            }
        }
    }

    return (
        <Layout>
            {loading && courseCatalogueList.length === 0 ? <LinearProgress color="primary" /> : (
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3} className={classes.sidebarMenu}>
                        <h2 className={classes.sidebarTitle}>Course Category</h2>
                        <MenuList id="simple-menu" open={true} className={classes.categoryList}>
                            <MenuItem
                                onClick={() => handleCLickMenuItem(null)}
                                id={!activeCatalogue ? 'selectedCategory' : ''}
                                style={{
                                    background: !activeCatalogue && "#3D7DDD",
                                    color: !activeCatalogue && "#fff",
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                <span style={{ flex: 1, whiteSpace: 'normal', wordBreak: 'break-word', paddingRight: 24 }}>
                                    All courses
                                </span>
                                <Badge
                                    max={9999}
                                    showZero
                                    className={classes.countIcon}
                                    badgeContent={catalogueTotalCount(courseCatalogueList)}
                                />
                            </MenuItem>
                            {(courseCatalogueList && courseCatalogueList.length > 0) ? courseCatalogueList.map(item => (
                                <MenuItem
                                    key={item.category}
                                    onClick={() => handleCLickMenuItem(item)}
                                    id={item.category === activeCatalogue ? 'selectedCategory' : ''}
                                    style={{
                                        background: item.category === activeCatalogue && "#3D7DDD",
                                        color: item.category === activeCatalogue && "#fff",
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                    title={item.category}
                                >
                                    <span style={{ flex: 1, whiteSpace: 'normal', wordBreak: 'break-word', paddingRight: 24 }}>
                                        {item.category}
                                    </span>
                                    <Badge
                                        max={9999}
                                        showZero
                                        className={classes.countIcon}
                                        badgeContent={item.count}
                                    />
                                </MenuItem>
                            )) : null}
                        </MenuList>
                    </Grid>
                    <Grid item xs={12} md={9} className={classes.mainContent} ref={coursesPanelRef}>
                        <Grid item container spacing={2} className={classes.coursesGrid}>
                            {pageCourses.map(course => (
                                <CourseItem
                                    key={course.uuid || course.name}
                                    handleCourseAction={handleCourseAction}
                                    course={course}
                                    scrollRootRef={coursesPanelRef}
                                />
                            ))}
                        </Grid>
                        {pagination.total_pages > 1 ? (
                            <div className={classes.paginationRow}>
                                <Pagination
                                    page={pagination.pageno + 1}
                                    count={pagination.total_pages}
                                    onChange={(_event, value) => updateCatalogueQuery({
                                        category: activeCatalogue,
                                        pageno: value - 1,
                                    })}
                                    color="primary"
                                    shape="rounded"
                                    variant="outlined"
                                />
                            </div>
                        ) : null}
                    </Grid>
                </Grid>
            )}
            <ConfirmationModal
                open={openConfirmModal}
                handleConfirm={handleRequestSubmit}
                title={<b>{`Request for ${selectedCourse && selectedCourse.name} Course`}</b>}
                loading={requestLoading}
                size={'sm'}
                handleClose={() => {
                    setSelectedCourse(null);
                    setOpenConfirmModal(false);
                }}>
                <Grid container style={{ marginTop: 10, marginBottom: 10 }}>
                    <Grid xs={12} item>
                        <Input
                            disableUnderline
                            value={comment}
                            type={'text'}
                            name="comment"
                            multiline
                            rows={4}
                            className={classes.inputStyle}
                            placeholder={"Comment"}
                            style={{ width: '100%' }}
                            color={'secondary'}
                            onChange={evt => setComment(evt.target.value)}
                        />
                    </Grid>
                </Grid>
            </ConfirmationModal>
        </Layout >
    );
}

export default CourseCatalogue;